function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "560.000000pt",
    height: "136.000000pt",
    viewBox: "0 0 560.000000 136.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,136.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2435 1279 c-220 -20 -491 -66 -710 -120 -172 -43 -375 -102 -375 -110 0 -15 481 -166 706 -222 392 -98 636 -134 990 -144 233 -6 370 2 609 38 172 27 694 38 900 20 264 -24 515 -70 688 -128 42 -14 80 -24 82 -21 9 8 -77 74 -146 112 -122 67 -280 115 -449 136 -121 15 -481 12 -640 -5 -74 -8 -223 -26 -330 -41 -176 -24 -226 -27 -515 -28 -264 -1 -340 2 -435 17 -253 40 -535 120 -681 193 -93 46 -135 109 -88 134 75 41 731 76 949 51 291 -33 516 -108 688 -227 l63 -44 94 26 c52 15 95 30 95 33 0 4 -30 19 -67 33 -38 15 -147 59 -243 98 -177 72 -294 113 -430 149 -202 53 -501 73 -755 50z",
    style: {
      fill: "#f00000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 980 c-184 -22 -390 -62 -390 -76 0 -3 15 -20 33 -40 70 -77 82 -109 82 -222 0 -56 1 -102 2 -102 1 0 10 14 19 32 50 96 175 182 284 195 27 3 50 9 50 12 0 3 -18 17 -40 31 -22 14 -40 28 -40 31 0 23 214 59 348 59 209 0 510 -46 1037 -160 127 -27 435 -76 435 -69 0 4 -19 12 -42 17 -24 5 -83 21 -133 36 -49 14 -137 39 -195 55 -534 154 -791 200 -1145 206 -126 2 -264 0 -305 -5z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 360 l0 -180 35 0 35 0 0 65 0 65 38 0 c110 1 162 39 162 119 0 81 -52 110 -197 111 l-73 0 0 -180z m184 94 c38 -37 5 -74 -65 -74 l-49 0 0 45 0 45 49 0 c32 0 55 -6 65 -16z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761 518 c-47 -121 -124 -316 -128 -325 -4 -9 7 -13 35 -13 37 0 41 3 56 40 l16 40 69 0 69 0 16 -40 c15 -37 18 -40 56 -40 l40 0 -13 33 c-7 17 -40 98 -72 180 l-59 147 -38 0 c-31 0 -40 -5 -47 -22z m72 -135 c9 -27 17 -51 17 -55 0 -5 -18 -8 -40 -8 -29 0 -40 4 -40 15 0 20 31 95 39 95 4 0 15 -21 24 -47z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047 534 c-4 -4 -7 -85 -7 -181 l0 -173 39 0 40 0 -3 52 c-2 41 2 56 22 80 13 15 28 26 32 23 5 -3 28 -39 52 -80 l43 -75 48 0 c26 0 47 2 47 4 0 3 -22 37 -48 78 -27 40 -57 88 -67 106 l-19 32 62 63 c34 34 62 66 62 70 0 4 -20 7 -45 7 -42 0 -48 -4 -114 -72 l-71 -73 -1 55 c-2 86 -2 85 -34 88 -17 2 -34 0 -38 -4z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651 525 c-10 -13 -131 -322 -131 -335 0 -6 15 -10 34 -10 30 0 36 4 50 40 l16 40 70 0 70 0 16 -40 c15 -37 19 -40 55 -40 l38 0 -23 63 c-53 138 -108 273 -118 285 -12 14 -65 13 -77 -3z m63 -138 c23 -62 21 -67 -24 -67 -29 0 -40 4 -40 15 0 21 31 95 40 95 4 0 15 -19 24 -43z",
    style: {
      fill: "#f00000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1931 531 c-17 -11 -12 -264 7 -299 32 -57 129 -78 205 -44 60 27 69 57 65 222 l-3 125 -32 2 -33 1 0 -123 c0 -71 -5 -135 -11 -149 -19 -41 -98 -45 -119 -6 -6 10 -10 75 -10 143 0 105 -3 126 -16 131 -21 8 -36 7 -53 -3z",
    style: {
      fill: "#f00000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2276 533 c-3 -4 -6 -17 -6 -29 0 -21 5 -23 53 -26 l52 -3 3 -147 3 -148 34 0 34 0 3 148 c2 109 6 147 16 148 6 1 28 2 47 3 32 1 35 4 35 30 l0 30 -134 0 c-74 0 -137 -3 -140 -6z",
    style: {
      fill: "#f00000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2684 526 c-86 -39 -119 -165 -69 -270 45 -95 202 -115 275 -34 73 80 61 231 -23 292 -35 26 -138 33 -183 12z m141 -68 c33 -29 48 -90 34 -143 -14 -51 -34 -73 -74 -81 -78 -14 -137 67 -115 161 11 51 50 85 95 85 21 0 44 -9 60 -22z",
    style: {
      fill: "#f00000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3189 512 c-58 -52 -36 -137 43 -165 24 -8 61 -21 83 -29 32 -11 40 -19 40 -38 0 -57 -102 -64 -130 -9 -12 22 -23 29 -45 29 -38 0 -44 -12 -26 -54 19 -44 55 -68 115 -74 99 -9 161 35 161 115 0 59 -28 86 -119 113 -40 12 -75 28 -78 36 -17 45 72 61 105 19 26 -33 82 -36 82 -4 0 57 -51 89 -139 89 -52 0 -65 -4 -92 -28z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3570 517 c-54 -36 -75 -81 -75 -162 0 -56 5 -78 23 -107 66 -107 243 -100 300 12 36 72 27 174 -22 229 -49 55 -166 70 -226 28z m161 -66 c26 -26 29 -36 29 -91 0 -75 -11 -97 -57 -116 -28 -12 -42 -13 -69 -4 -44 15 -64 53 -64 125 0 49 4 60 29 86 22 21 39 29 66 29 27 0 44 -8 66 -29z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3914 526 c-3 -8 -4 -76 -2 -150 l3 -136 33 -32 c31 -31 36 -33 107 -33 71 0 76 2 107 32 l32 33 1 147 0 148 -35 0 -35 0 -5 -140 -5 -140 -27 -13 c-31 -14 -71 -8 -90 16 -9 10 -14 59 -16 149 l-4 133 -29 0 c-16 0 -32 -6 -35 -14z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4287 533 c-4 -3 -7 -84 -7 -180 l0 -173 40 0 40 0 0 75 c0 67 2 75 19 75 26 0 55 -26 99 -90 35 -50 42 -55 80 -58 23 -2 42 0 42 3 0 11 -72 120 -88 134 -13 10 -14 14 -4 18 7 3 25 15 39 27 21 18 26 32 27 68 1 55 -20 83 -73 98 -40 11 -204 14 -214 3z m211 -93 c4 -40 -10 -50 -74 -53 l-59 -2 -3 43 -3 43 68 -3 c64 -3 68 -4 71 -28z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4720 517 c-53 -35 -75 -81 -75 -157 0 -86 26 -136 86 -168 80 -43 172 -18 212 59 l17 34 -27 12 c-41 18 -46 16 -63 -19 -19 -40 -58 -55 -97 -36 -38 18 -53 52 -53 121 0 51 4 62 29 88 19 18 40 29 58 29 34 0 73 -25 73 -46 0 -12 7 -14 33 -9 42 9 42 11 31 42 -24 70 -153 99 -224 50z",
    style: {
      fill: "#969595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5037 534 c-4 -4 -7 -85 -7 -181 l0 -173 140 0 140 0 0 30 0 30 -100 0 -100 0 0 45 0 45 85 0 85 0 0 35 0 35 -85 0 -85 0 0 35 0 34 93 3 92 3 0 30 0 30 -126 3 c-69 1 -128 -1 -132 -4z",
    style: {
      fill: "#969595"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9a7a698d9451dd745063d9342344975d.svg";
export { ForwardRef as ReactComponent };